<script lang="ts">
    export let id: string | null = null;
    export let testid: string | null = null;
    export let primary: boolean = false;
    export let secodary: boolean = false;
    export let active: boolean = false;
    export let loading: boolean = false;
    export let disabled: boolean = false;
    export let theme: 'light' | 'light-strong' | 'dark' | 'dark-strong' = 'light';

    const themeClasses = {
        light: '',
        'light-strong': 'btn--light-strong',
        dark: 'btn--dark',
        'dark-strong': 'btn--dark-strong'
    };

    $: thematic = themeClasses[theme] || '';
</script>

<button
    {id}
    class="btn {thematic}"
    class:btn--primary={primary}
    class:btn--secondary={secodary && !primary}
    class:btn--active={active}
    class:btn--loading={loading}
    on:click
    {disabled}
    data-testid={testid}
>
    <div class="btn__text"><slot /></div>
</button>
